import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { speaker } from '@/data/speaker';
import '@/styles/home.css';

const links = [
  { label: 'Temas', href: '#temas' },
  { label: 'Quem fala', href: '#sobre' },
  { label: 'Na mídia', href: '#midia' },
  { label: 'Formação', href: '#aprender' },
];

export default function HomeNavigation() {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && open) { setOpen(false); toggle.current?.focus(); }
    };
    const media = window.matchMedia('(min-width: 1024px)');
    const onResize = () => { if (media.matches) setOpen(false); };
    document.addEventListener('keydown', onKey);
    media.addEventListener('change', onResize);
    return () => { document.removeEventListener('keydown', onKey); media.removeEventListener('change', onResize); };
  }, [open]);
  return (
    <header className="home-nav pulse-surface">
      <a className="pulse-skip" href="#home-content">Pular para o conteúdo</a>
      <div className="home-nav-inner">
        <Link to="/" className="home-brand" aria-label="Johnny Vaz, início"><img src="/images/logo/logo-jv-tree.png" alt="" width={34} height={34} /><span>JOHNNY VAZ<span className="home-brand-dot">.</span></span></Link>
        <nav className="home-desktop-nav" aria-label="Navegação principal">{links.map(link => <a key={link.href} href={link.href}>{link.label}</a>)}</nav>
        <Link className="home-nav-cta" to="/palestras#convite">Convidar para palestrar <ArrowUpRight size={16} aria-hidden="true" /></Link>
        <button ref={toggle} className="home-menu-toggle" aria-label={open ? 'Fechar menu' : 'Abrir menu'} aria-expanded={open} aria-controls="home-mobile-nav" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
      </div>
      <nav id="home-mobile-nav" className="home-mobile-nav" aria-label="Navegação móvel" hidden={!open}>{links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)}>{link.label}<ArrowUpRight size={18} aria-hidden="true" /></a>)}<Link to="/palestras" onClick={() => setOpen(false)}>Palestras e convite<ArrowUpRight size={18} aria-hidden="true" /></Link></nav>
    </header>
  );
}
